import { Parse } from "parse";
import UIkit from 'uikit';

Parse.initialize("AWkPplHMIY9BT8RKZR7cYj6KPMLuMeJ1GMGGOjDk", "bd328hdyqbuyg2976te31eghdt7679F6F6DF7GgFG9Ff");
Parse.serverURL = 'https://api.snypinc.com/parse';

class Barber extends Parse.User {
    constructor(attributes) {
        super(attributes);
    }

    getEmail() {
        return this.get('email');
    }
}
Parse.Object.registerSubclass('_User', Barber);

function registerBarber() {
    Parse.User.logOut();
    const email = document.getElementById('email-field').value;
    const fname = document.getElementById('fname-field').value;
    const lname = document.getElementById('lname-field').value;
    const license = document.getElementById('license-field').value;
    const dob = document.getElementById('dob-field').value;
    const photoid = document.getElementById('photoid').files[0];
    const photoidFile = new Parse.File('photoid', photoid);
    const customUser = new Barber({ fname: fname, lname: lname, license: license, dob: dob, active: false, status: 'new' });
    customUser.setUsername(email);
    customUser.setPassword(generatePassword());
    customUser.setEmail(email);
    customUser.signUp().then((user) => {
        user.set('photoid', photoidFile);
        user.save();
        UIkit.modal(document.getElementById('register-docs')).hide();
        UIkit.notification("Your registration has been submitted! We will contact you with further instructions.", {status:'success'})
        Parse.Cloud.run('sendWelcomeEmail', {
            data: {
                email: email,
                name: `${fname} ${lname}`
            }
          });
    }).catch((error) => {
        UIkit.notification(error.message, {status:'danger'})
    });
}

function generatePassword(length=32) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789[]:;<>?/!@#$%^&*()|.,~';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
}

const slider = document.getElementById("snypRange");
const count = document.getElementById("snypCount");
const earn = document.getElementById("snypEarn");
if (slider) {
    slider.addEventListener("input", function() {
        count.innerHTML = this.value;
        earn.innerHTML = this.value * 75;
    });
}

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const email = document.getElementById('email-field');
const btn1 = document.getElementById('step1-next');
function enableNext1() {
    if (emailRegex.test(email.value) === true) btn1.classList.replace('uk-disabled', 'uk-button-primary')
    else btn1.classList.replace('uk-button-primary', 'uk-disabled');
}
email.addEventListener('change', () => {enableNext1()});

const fname = document.getElementById('fname-field');
const lname = document.getElementById('lname-field');
const state = document.getElementById('state-field');
const btn2 = document.getElementById('step2-next');
function enableNext2() {
    if (fname.value && lname.value) btn2.classList.replace('uk-disabled', 'uk-button-primary')
    else btn2.classList.replace('uk-button-primary', 'uk-disabled');
}
fname.addEventListener('change', () => {enableNext2()});
lname.addEventListener('change', () => {enableNext2()});
state.addEventListener('change', () => {enableNext2()});

const form = document.getElementById("barber-register");
const photoid = document.getElementById('photoid');
const license = document.getElementById('license-field');
const dob = document.getElementById('dob-field');
const btn = document.getElementById('submit-registration');
function enableSubmit() {
    if (photoid.files?.length > 0 && license.value && dob.value) btn.removeAttribute('disabled')
    else btn.setAttribute('disabled', 'true');
}
photoid.addEventListener('change', () => {enableSubmit()});
license.addEventListener('change', () => {enableSubmit()});
dob.addEventListener('change', () => {enableSubmit()});
btn.addEventListener('click', () => {registerBarber()});
form.addEventListener('submit', () => {registerBarber()});